import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type PatchBonusEnabledPayload = {
  user_id: string;
  bonus_enabled: boolean;
};

export type PatchBonusEnabledResponse = {
  message?: string;
  [key: string]: unknown;
} | null;

const patchBonusEnabled = async ({
  user_id,
  bonus_enabled,
}: PatchBonusEnabledPayload): Promise<PatchBonusEnabledResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.patch(
    API_ROUTES.USER_BONUS_ENABLED.replace("{user_id}", user_id),
    { bonus_enabled },
  );

  return response?.data ?? null;
};

export const usePatchBonusEnabled = () =>
  useMutation<PatchBonusEnabledResponse, Error, PatchBonusEnabledPayload>({
    mutationKey: ["patchBonusEnabled"],
    mutationFn: patchBonusEnabled,
  });
